import { Profile } from '@weblite/sahab-profile-action/profile'
import { createKeyvalStorage, createKeyvalView } from '../lib/keyval.storage'

const key = 'profile'

export interface UserProfile extends Profile {
  extra: {
    networks: number[]
  }
}

export const profileStorage = createKeyvalStorage<UserProfile>(key)

export const profileView = createKeyvalView<UserProfile>(key)
